import { AppHeader as InternalAppHeader } from "@vetty/internal-ui";
import { Breadcumbs } from "@/components";
import { logoutUser } from "@/helpers";
import { useAuth } from "@/hooks";
import { useRouter } from '@/lib/router-navigation';

const AppHeader = () => {
  const { user } = useAuth();
  const router = useRouter();

  return (
    <InternalAppHeader
      left={<Breadcumbs />}
      user={
        user
          ? {
              firstName: user.firstName,
              lastName: user.lastName,
              email: user.email,
              username: user.username,
              role: user.role,
            }
          : null
      }
      onSettings={() => router.push("/settings")}
      onLogout={async () => {
        await logoutUser();
        window.location.assign("/api/auth/login?returnTo=%2Foverview");
      }}
    />
  );
};

export { AppHeader };
